import React from 'react'
import { PrimaryLink } from 'jl-ui-kit/elements/link/Link'
import styles from './GenericError.scss'

type Props = {
  body: string
  ctaText: string
}

export default function GenericError({ body, ctaText }: Props): JSX.Element {
  return (
    <div className={styles.container} data-test="generic-error">
      <p data-test="error-body">{body}</p>

      <div>
        <PrimaryLink to="/#homepage" external className={styles.cta} data-test="error-cta">
          {ctaText}
        </PrimaryLink>
      </div>
    </div>
  )
}
